import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBomb,
  faBars,
  faChevronDown,
  faChevronRight,
  faSearch,
  faShoppingCart,
  faFileArchive,
  faFileMusic,
  faFileVideo,
  faFileChartPie,
  faFileAlt,
  faFileSpreadsheet,
  faFilePdf,
  faFileImage,
  faFile,
  faMinus,
  faChevronLeft,
  faUserCircle,
  faSpinner,
  faExclamationCircle,
  faCheck,
  faMapMarkerAlt,
  faCreditCard,
  faSyncAlt,
  faExternalLink,
  faArrowToTop,
  faCog,
  faTimes,
  faPlay,
  faPause,
  faExpandArrowsAlt,
  faCompressArrowsAlt,
  faHome,
  faAngleRight
} from "@fortawesome/pro-solid-svg-icons";

import {
  faTimes as faTimesRegular,
  faClock as faClockRegular,
  faCalendarAlt as faCalendarAltRegular,
  faTrashAlt,
  faEnvelopeOpenText,
  faPaperPlane,
  faFile as faFileRegular,
  faAngleRight as faAngleRightRegular,
  faEnvelope as faEnvelopeRegular,
  faArrowToBottom as faArrowToBottomRegular,
  faLink as faLinkRegular,
  faChevronRight as faChevronRightRegular
} from "@fortawesome/pro-regular-svg-icons";

import {
  faTimes as faTimesLight,
  faFilter as faFilterLight
} from "@fortawesome/pro-light-svg-icons";

import {
  faYoutubeSquare,
  faLinkedin,
  faTwitterSquare,
  faFacebookSquare,
  faInstagramSquare
} from "@fortawesome/free-brands-svg-icons";

library.add( faAngleRightRegular );
library.add( faPlay );
library.add( faPause );
library.add( faFilterLight );
library.add( faEnvelopeRegular );
library.add( faLinkRegular );
library.add( faArrowToBottomRegular );
library.add( faChevronRightRegular );
library.add( faBomb );
library.add( faBars );
library.add( faChevronDown );
library.add( faChevronRight );
library.add( faChevronLeft );
library.add( faSearch );
library.add( faShoppingCart );
library.add( faFileArchive );
library.add( faFileMusic );
library.add( faFileVideo );
library.add( faFileChartPie );
library.add( faFileAlt );
library.add( faFileSpreadsheet );
library.add( faFilePdf );
library.add( faFileImage );
library.add( faFile );
library.add( faMinus );
library.add( faUserCircle );
library.add( faTimes );
library.add( faTimesLight );
library.add( faSpinner );
library.add( faYoutubeSquare );
library.add( faLinkedin );
library.add( faTwitterSquare );
library.add( faFacebookSquare );
library.add( faInstagramSquare );
library.add( faExclamationCircle );
library.add( faCheck );
library.add( faClockRegular );
library.add( faCalendarAltRegular );
library.add( faMapMarkerAlt );
library.add( faCreditCard );
library.add( faSyncAlt );
library.add( faTrashAlt );
library.add( faEnvelopeOpenText );
library.add( faPaperPlane );
library.add( faFileRegular );
library.add( faAngleRight );
library.add( faExternalLink );
library.add( faArrowToTop );
library.add( faCog );
library.add( faTimesRegular );
library.add( faExpandArrowsAlt );
library.add( faCompressArrowsAlt );
library.add( faHome );
